<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <div>
  <el-dialog title="修改区域代理" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="选择用户" :label-width="formLabelWidth">
        <el-row>
          <div class="img">
            <img :src="form.user.avatarUrl" width="100" height="100" />
            <span>ID:{{form.user_id}}</span><br>
            <span>昵称:{{form.user.nickName}}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="代理级别" :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.level" :label="1">省代</el-radio>
          <el-radio v-model="form.level" :label="2">市代</el-radio>
          <el-radio v-model="form.level" :label="3">区代</el-radio>
          <el-radio v-model="form.level" :label="4">街道</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="代理区域" :label-width="formLabelWidth" v-if="form.level>0">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity" v-if="form.level>0">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!='' && form.level>1" v-model="form.city_id" placeholder="市" @change="initRegion" >
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!='' && form.level>2" v-model="form.region_id" placeholder="区" @change="initStreet" >
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>
        <el-select v-if="form.region_id!='' && form.level>3" clearable v-model="form.street_id" placeholder="街道/镇/乡" >
          <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['street']"
            :key='index3'></el-option>
        </el-select>

      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import RegionagentApi from '@/api/regionagent.js';
  import select_district from '@/utils/select.district.js';
  export default {
    data() {
      return {
        /*省市区*/
        areaList: select_district,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
      };
    },
    props: ['open_edit','form'],
    created() {
       this.dialogVisible = this.open_edit;
    },
    methods: {
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },
      /*初始化街道id*/
      initStreet() {
        this.form.street_id = ''
      },
      /*修改用户*/
      editUser() {
        let self = this;

        let params = self.form;
        console.log(params)
        if(!params.user_id){
            this.showMessage('请选择用户');
            return ;
        }
        if(!params.level){
            this.showMessage('前选择代理级别');
            return ;
        }
        self.loading = true;
        RegionagentApi.regionagentEdit(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        console.log(e.params[0])
        this.form.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/regionagent/regionagent/dialog/Edit.vue